var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockheedMartinLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 334.05 54.81",
    style: {
      enableBackground: "new 0 0 334.05 54.81"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#003478;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.05,26.29h5.25L10.12,41.3h8.38l-0.78,3.67H4.09L8.05,26.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.64,28.36c2.87-2.38,6.5-2.59,7.87-2.59c7.45,0,8.33,5.36,7.35,9.91c-1.58,7.45-7.35,9.73-11.8,9.73 c-4.97,0-9.01-2.74-7.53-9.7C20.78,34.47,21.79,30.75,24.64,28.36z M28.94,41.61c3.7,0,5.05-3.42,5.59-6 c0.54-2.61,0.21-3.91-0.18-4.74c-0.54-1.04-1.68-1.35-2.82-1.35c-3.42,0-4.97,2.95-5.67,6.16 C25.24,38.66,25.49,41.61,28.94,41.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.41,32.17c0.18-1.89-1.01-2.59-2.48-2.59c-3.13,0-4.68,2.87-5.41,6.29c-0.26,1.14-1.22,5.85,2.79,5.85 c2.74,0,3.44-1.99,3.7-2.72h5.38c-1.27,5.85-7.32,6.34-9.76,6.34c-1.81,0-4.94-0.31-6.57-2.48c-1.58-2.17-1.29-5.15-0.88-7.09 c0.54-2.56,1.68-5.12,3.86-7.12c2.38-2.17,4.97-2.74,7.69-2.74c3.03,0,5.18,0.72,6.31,2.28c1.17,1.6,0.83,3.29,0.7,3.98H55.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.14,26.29h5.25l-1.73,8.2l7.71-8.2h6.13l-8.18,8.23l4.74,10.46h-6.42l-4.09-9.94l-2.12,9.94h-5.25 L65.14,26.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.98,26.29h5.23l-1.53,7.3h6.24l1.53-7.3h5.25l-3.96,18.68h-5.25l1.6-7.56h-6.26l-1.6,7.56h-5.2 L84.98,26.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.22,26.35h14.03l-0.75,3.57h-8.9l-0.83,3.88h8.38l-0.78,3.57h-8.38l-0.83,3.99h9.11l-0.78,3.62h-14.23 L105.22,26.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.48,26.35h14.03l-0.75,3.57h-8.9l-0.83,3.88h8.38l-0.78,3.57h-8.38l-0.83,3.99h9.11l-0.78,3.62h-14.23 L122.48,26.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.84,26.29h7.89c2.23,0,5.15,0.23,6.81,1.55c2.36,1.89,2.46,4.97,1.86,7.74 c-0.88,4.14-2.85,7.2-6.94,8.67c-2.07,0.72-4.35,0.72-5.64,0.72h-7.94L139.84,26.29z M141.96,41.38h2.23 c3.44-0.03,5.95-1.5,6.88-5.85c1.19-5.67-3.05-5.67-4.63-5.67l-2.04-0.03L141.96,41.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.75,26.29h8.15l0.44,12.66l5.62-12.66l8.15-0.03l-3.96,18.71h-4.89l3.57-15.68l-7.76,15.68h-4.66 l-0.91-15.81l-3.24,15.81h-4.48L169.75,26.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.58,26.29h6.31l3.42,18.68h-5.85l-0.49-3.75h-7.48l-2.07,3.75h-5.18L201.58,26.29z M204.5,37.78 l-0.75-7.84h-0.08l-4.24,7.84H204.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.23,26.29h8.64c3.36,0,4.61,0.21,5.46,1.35c0.47,0.57,0.96,1.6,0.54,3.62 c-0.44,2.04-1.45,2.92-2.46,3.47c-1.35,0.75-2.51,0.88-3.05,0.96l-0.03,0.1c3.62,0.1,3.47,1.71,3.29,4.58 c-0.1,1.27-0.26,3.29-0.1,4.61h-5.62c-0.08-1.14,0.1-2.56,0.29-4.22c0.23-2.25,0.34-3.08-1.99-3.08h-2.17l-1.55,7.3h-5.2 L217.23,26.29z M220.75,34.32h1.94c1.14,0,1.71,0,2.17-0.16c1.22-0.36,1.68-1.53,1.81-2.12c0.49-2.3-1.53-2.3-3.03-2.3h-1.94 L220.75,34.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.41,29.99h-5.69l0.78-3.7h16.74l-0.78,3.7h-5.82l-3.18,14.98h-5.23L239.41,29.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.04,26.29h5.33l-3.96,18.68h-5.33L253.04,26.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.84,26.29h7.14l3.36,13.92l2.9-13.92h4.53l-3.96,18.68h-6.99l-3.36-14.52l-3.03,14.52h-4.55 L261.84,26.29z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.45,21.27l5.59-18.93c0.07-0.24-0.24-0.41-0.41-0.23l-17.77,19.15H272c-0.31,0-0.33,0.46-0.01,0.48 l22.62,0.86l4.67,0.27l4.68,0.31l0.24-1.92h-6.14l9.59-8.73l-1.67,8.73l-2.44,12.78l-3.21,16.86c-0.06,0.3,0.39,0.41,0.47,0.11 l4.37-17.77l24.22-11.53c0.23-0.11,0.15-0.46-0.11-0.46H308.45z M307.87,23.39l8.93,0.52l-10.83,6.43L307.87,23.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.68,23.73L294,23.52l-9.81,10.16c-0.21,0.22,0.1,0.55,0.33,0.35L295.68,23.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.15,34.68l0.31-2.41l-20.88,12.25c-0.26,0.16-0.05,0.56,0.23,0.42L302.15,34.68z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockheedMartinLogo);
export default __webpack_public_path__ + "static/media/lockheed-martin-logo.7ba31585e81dca5bf022bb74615225fd.svg";
export { ForwardRef as ReactComponent };